import(/* webpackMode: "eager" */ "/builds/irtech/investment-research-distribution/forge-render/apps/render/src/app/error.tsx");
